import { render, staticRenderFns } from "./PurchaseAndSale.vue?vue&type=template&id=77a64090&scoped=true"
import script from "./PurchaseAndSale.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSale.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSale.vue?vue&type=style&index=0&id=77a64090&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a64090",
  null
  
)

export default component.exports